export async function submitDatadogMetrics(metrics) {
  const {
    client,
    v1
  } = await import("@datadog/datadog-api-client");
  const configuration = client.createConfiguration();
  const apiInstance = new v1.MetricsApi(configuration);
  const params = {
    body: {
      series: toDatadogSeries(metrics)
    }
  };
  return apiInstance.submitMetrics(params);
}
function toDatadogSeries(metrics) {
  return metrics.map(metric => {
    return {
      metric: metric.name,
      tags: metric.tags,
      points: [[now(), metric.value]],
      type: "count"
    };
  });
}

/**
 * Identify DD user session from a ControlTower User
 * See https://docs.datadoghq.com/real_user_monitoring/browser/advanced_configuration/?tab=npm#identify-user-session
 *
 * @param user The ControlTower user
 */
export async function setDatadogUser(user) {
  const {
    datadogRum
  } = await import("@datadog/browser-rum");
  datadogRum.setUser(user);
}

/**
 *
 * Clear all Datadog user information
 */
export async function resetDatadogUser() {
  const {
    datadogRum
  } = await import("@datadog/browser-rum");
  datadogRum.clearUser();
}
function now() {
  return new Date().getTime() / 1000;
}